export default () => {
	const pageContentsEl = document.getElementById("page-contents");
	const backToTopBar = document.getElementById("back-to-top-bar");
	const targetIdAttr = "data-anchor-target-id";

	if (pageContentsEl !== null && backToTopBar !== null) {
		for (const item of document.querySelectorAll("[" + targetIdAttr + "]")) {
			const linkItem = item.querySelector("a");
			linkItem.addEventListener("click", (e) => {
				e.preventDefault();

				const targetId = item.getAttribute(targetIdAttr);
				const targetEl = document.getElementById(targetId);

				if (targetEl !== null) {
					const bodyRect = document.body.getBoundingClientRect().top;
					const elementRect = targetEl.getBoundingClientRect().top;
					const elementPosition = elementRect - bodyRect;
					const offsetPosition = elementPosition - backToTopBar.offsetHeight;

					window.scrollTo({
						top: offsetPosition,
						behavior: "smooth",
					});
				}
			});
		}

		let pageContentsObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				let ev = null;

				if (!entry.isIntersecting) {
					ev = new Event("page-contents-outside", {
						bubbles: true,
					});
				} else {
					ev = new Event("page-contents-inside", {
						bubbles: true,
					});
				}

				if (ev !== null) {
					pageContentsEl.dispatchEvent(ev);
				}
			});
		});
		pageContentsObserver.observe(pageContentsEl);
	}

	const pageContentsSidebar = document.getElementById("page-contents-sidebar");
	if (pageContentsSidebar !== null) {
		const activeClass = "is-active";
		const visibleClass = "is-visible";

		document.addEventListener("active-heading-changed", (e) => {
			const id = e.detail;
			for (const el of pageContentsSidebar.querySelectorAll(
				"[" + targetIdAttr + "]",
			)) {
				if (el.getAttribute(targetIdAttr) === id) {
					el.classList.add(activeClass);
				} else {
					el.classList.remove(activeClass);
				}
			}
		});

		document.addEventListener("page-contents-outside", (e) => {
			for (const item of pageContentsSidebar.querySelectorAll("a")) {
				item.removeAttribute("tabindex");
			}
			pageContentsSidebar.classList.add(visibleClass);
		});
		document.addEventListener("page-contents-inside", (e) => {
			for (const item of pageContentsSidebar.querySelectorAll("a")) {
				item.setAttribute("tabindex", "-1");
			}
			pageContentsSidebar.classList.remove(visibleClass);
		});

		let observer = new IntersectionObserver(
			(entries, observer) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const target = entry.target;
						const ev = new CustomEvent("active-heading-changed", {
							bubbles: true,
							detail: target.id,
						});
						target.dispatchEvent(ev);
					}
				});
			},
			{
				rootMargin: "-50%",
			},
		);

		for (const el of document.querySelectorAll(
			".matrix-content__block--heading",
		)) {
			observer.observe(el);
		}
	}
};
